module.exports = __webpack_public_path__ + "img/HFIG-600-timedomain.94fc3788.png";